import { DAY, MONTH } from 'models';
import {
  MonthDayProperty,
  MonthDayPropertyPulldown,
  MONTH_DAY_PROPERTY_INPUT_TYPE,
  FormPageInputItem,
  FormPageInputItemMonthDay,
  FormPageInputItemMonthDayFree,
  FormPageInputItemMonthDayPulldown,
  INPUT_ITEM_TYPE,
} from 'shared';

const handleFree = (
  formPageInputItem?: FormPageInputItem
): FormPageInputItemMonthDayFree => {
  const inputItemType = INPUT_ITEM_TYPE.monthDayFree;
  if (formPageInputItem?.inputItemType === INPUT_ITEM_TYPE.monthDayFree) {
    return {
      inputItemType,
      month: formPageInputItem.month || '',
      day: formPageInputItem.day || '',
    };
  }
  return {
    inputItemType,
    month: '',
    day: '',
  };
};

const isMonthDayPulldown = (
  formPageInputItem?: FormPageInputItem
): formPageInputItem is FormPageInputItemMonthDayPulldown =>
  formPageInputItem?.inputItemType === INPUT_ITEM_TYPE.monthDayPulldown;

const handlePulldown = (
  inputFormat: MonthDayPropertyPulldown['inputFormat'],
  formPageInputItem?: FormPageInputItem
): FormPageInputItemMonthDayPulldown => {
  const { unselectedState } = inputFormat;
  const inputItemType = INPUT_ITEM_TYPE.monthDayPulldown;
  const defaultMonth = unselectedState ? '' : MONTH[0];
  const defaultDay = unselectedState ? '' : DAY[0];

  if (isMonthDayPulldown(formPageInputItem)) {
    return {
      inputItemType,
      month: formPageInputItem.month || defaultMonth,
      day: formPageInputItem.day || defaultDay,
    };
  }
  return {
    inputItemType,
    month: defaultMonth,
    day: defaultDay,
  };
};

export const convertMonthDayInitialValue = (
  property: MonthDayProperty,
  formPageInputItem?: FormPageInputItem
): FormPageInputItemMonthDay => {
  const { free, pulldown } = MONTH_DAY_PROPERTY_INPUT_TYPE;
  switch (property.inputFormat.inputType) {
    case free: {
      return handleFree(formPageInputItem);
    }
    case pulldown:
      return handlePulldown(property.inputFormat, formPageInputItem);
  }
};
